import React from 'react';
import './payment.css';
import { useDispatch, useSelector } from "react-redux";
import { dropdownAction } from "../../redux/rootReducer";

const Payment = ({ payment, handler, totalSum, discountValue }) => {
    const dispatch = useDispatch();

    const dropdown = useSelector(state => state.dropdown);
    const payment_methods = useSelector(state => state.payment_methods);
    const discount = useSelector(state => state.discount);

    // Функция подсчёта суммы со скидкой
    const getTotal = percent => {
        return +(totalSum - (totalSum / 100 * percent)).toFixed(2);
    };

    return (
        <div className="payments">
            {
                payment?.map((p, index) => (
                    <div className="payment" key={ p.index }>
                        <div className="payment__item">
                            <div className="input__caption">Стоимость</div>
                            {
                                payment[index + 1]
                                ?
                                    <div className="input input--inactive">{ p.cost }</div>
                                :
                                    <input type="number" className="input"
                                           value={ p.cost }
                                           onInput={ event => {
                                               let newPayment = payment.map(el => {
                                                   // Находим нужный элемент и меняем в нём стоимость
                                                   if (el.index === p.index) {
                                                       return { ...p, cost: event.target.value };
                                                   }
                                                   // Иначе оставляем элемент как есть
                                                   else {
                                                       return el;
                                                   }
                                               });

                                               // Если редактируем не первых элемент
                                               if (p.index !== 1) {
                                                   let tmp = { ...newPayment[0] };
                                                   tmp.cost = +(parseFloat(getTotal(discountValue.percent)) -
                                                       parseFloat(newPayment.filter(el => el.index !== 1).reduce((prev, { cost }) => prev + parseFloat(cost || 0), 0)))
                                                       .toFixed(2);

                                                   newPayment[0] = tmp;
                                               }

                                               handler({
                                                   payment: newPayment,
                                                   discount: payment.length === 1 ? { id: '', name: 'Нет скидки', percent: '0' } : discountValue,
                                                   total_sum: payment.length === 1 ? event.target.value : totalSum
                                               });
                                           } }
                                    />
                            }
                        </div>
                        {
                            payment_methods.length > 0
                                ?
                                <div className="payment__item">
                                    <div className="input__caption">Метод оплаты</div>
                                    <div className="dropdown">
                                        <div className="input input--tick"
                                             onClick={ () => dropdown === 'payment_method' + p.index ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('payment_method' + p.index)) }
                                        >{ p.payment_method.name }</div>
                                        <div className={ `dropdown__items ${ dropdown === 'payment_method' + p.index ? 'dropdown__items--open' : false }` }>
                                            {
                                                payment_methods.map(elem => {
                                                    // Скрываем неактивные методы
                                                    if (elem?.active === '0') return;
                                                    return (
                                                        <div className="dropdown__item" key={ elem.id }
                                                             onClick={ () => {
                                                                 handler({
                                                                     payment: payment.map(el => {
                                                                         // Находим нужный элемент и меняем в нём стоимость
                                                                         if (el.index === p.index) {
                                                                             return { ...p, payment_method: elem };
                                                                         }
                                                                         // Иначе оставляем элемент как есть
                                                                         else {
                                                                             return el;
                                                                         }
                                                                     }),
                                                                     discount: discountValue,
                                                                     total_sum: totalSum
                                                                 });
                                                                 dispatch(dropdownAction(null));
                                                             } }
                                                        >{ elem.name }</div>
                                                    );
                                                })
                                            }
                                        </div>
                                    </div>
                                </div>
                                : false
                        }
                        <i className={ `payment__remove ${ p.index === 1 ? 'payment__remove--invisible' : '' }` }
                           onClick={ () => {
                               let newPayment = JSON.parse(JSON.stringify(payment));
                               newPayment[0].cost = parseFloat(newPayment[0].cost) + parseFloat(p.cost || 0);
                               handler({
                                   payment: newPayment.filter(el => el.index !== p.index),
                                   discount: discountValue,
                                   total_sum: totalSum
                               });
                           } }
                        />
                    </div>
                ))
            }
            <div className="payment__surcharge"
                onClick={ () => {
                    // Находим самый большой индекс платежа
                    let maxIndex = 0;
                    payment.forEach(el => {
                        if (el.index > maxIndex) maxIndex = el.index;
                    });
                    // Добавляем новый платёж
                    handler({
                        payment: [...payment, { index: maxIndex + 1, cost: '', payment_method: { id: '', name: '' }} ],
                        discount: discountValue,
                        total_sum: totalSum
                    });
                } }
            >Доплата</div>
            {
                discount.length > 1 && payment[0]?.cost && payment[0]?.cost !== ''
                    ?
                    <div className="payment__discount">
                        <div className="input__caption">Скидка</div>
                        <div className="dropdown">
                            <div className="input input--tick"
                                 onClick={ () => dropdown === 'discount' ? dispatch(dropdownAction(null)) : dispatch(dropdownAction('discount')) }
                            >{ discountValue?.name }</div>
                            <div className={ `dropdown__items ${ dropdown === 'discount' ? 'dropdown__items--open' : false }` }>
                                {
                                    discount.map(elem => {
                                        return (
                                            <div className="dropdown__item" key={ elem.id }
                                                 onClick={ () => {
                                                     handler({
                                                         payment: [{ ...payment[0], cost: getTotal(elem.percent) }],
                                                         discount: elem,
                                                         total_sum: totalSum
                                                     });

                                                     // Меняем значение скидки
                                                     dispatch(dropdownAction(null));
                                                 } }
                                            >{ elem.name }</div>
                                        );
                                    })
                                }
                            </div>
                        </div>
                        <div className="payment__total">{ `Со скидкой: ${ getTotal(discountValue.percent) }` }</div>
                    </div>
                    : false
            }
        </div>
    );
};

export default Payment;